import React from "react";
import { HashLoader } from "react-spinners";

function Loader({ loading }) {
  if (!loading) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-white bg-opacity-80 z-50">
      <HashLoader color="#0072ff" size={50} />
    </div>
  );
}

export default Loader;
